import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M1.88 7C1.39399 7 1 6.55228 1 6C1 5.44772 1.39399 5 1.88 5H22.12C22.606 5 23 5.44772 23 6C23 6.55228 22.606 7 22.12 7H1.88Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M1.88 13C1.39399 13 1 12.5523 1 12C1 11.4477 1.39399 11 1.88 11H22.12C22.606 11 23 11.4477 23 12C23 12.5523 22.606 13 22.12 13H1.88Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M1.88 19C1.39399 19 1 18.5523 1 18C1 17.4477 1.39399 17 1.88 17H22.12C22.606 17 23 17.4477 23 18C23 18.5523 22.606 19 22.12 19H1.88Z",
  fill: "currentColor"
}, null, -1)

import VIconBase from '../VIconBase.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'MenuIcon',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(VIconBase, {
    name: "menu",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _hoisted_2,
      _hoisted_3
    ]),
    _: 1
  }))
}
}

})